import { render } from "./센터소개.vue?vue&type=template&id=690a29c4"
import script from "./센터소개.vue?vue&type=script&lang=js"
export * from "./센터소개.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__